import React,{useEffect, useState} from 'react';
import './gallery.css';
import cross from'../../images/cross.png'
import bigBoobsNaked from'../../images/bigBoobsNaked.jpg'
import doggyRubb from'../../images/doggyRubb.gif'
import img139 from'../../images/139.jpg'
import img140 from'../../images/140.jpg'
import img146 from'../../images/146.jpg'

function Gallery({goBack, gallery, galleryWork}) {
  const [pics, setPics] = useState();
  const [fullImg, setFullImg] = useState();
  const [picsWork, setPicsWork] = useState();
  const [switcher, setSwitcher] = useState(false);
  const [white, setWhite] = useState(1);
  const [index, setIndex] = useState(14);
  const [opac, setOpac] = useState(0);
  useEffect(() => {
    changeWhite(true);

  setPics(Array.from(gallery.entries()));
  setPicsWork(Array.from(galleryWork.entries()));
},[]);

async function openImg(e){
  setFullImg(e.target.src);
  await changeOnOff(false, setOpac);
}

async function closeImg(){
  await changeOnOff(true, setOpac);
  setFullImg(undefined);
}

function switcherSet(){
  setSwitcher(prev => !prev);
}
  async function goToMenu(){
    setIndex(14);
    await changeWhite();
    goBack();
  }

  function changeWhite(toLow){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.05;
      setWhite(op);
      setTimeout(ChangetoLow, 3);
    }else{
      setIndex(0);
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.05;
    setWhite(op);
    setTimeout(change, 3);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }

  function changeOnOff(toLow, setter){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.07;
      setter(op);
      setTimeout(ChangetoLow, 5);
    }else{
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.02;
    setter(op);
    setTimeout(change, 5);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }


return(
<div className='menu'>
{fullImg && <div className="fullScreen" style={{opacity:opac}}>
<img onClick={closeImg} src={cross} style={{cursor:"pointer"}}/>
<div><img src={fullImg}/></div></div>
}
<div className="arrow-1" onClick={goToMenu}>
    <div></div>
</div>
<div className="switch">
{!switcher && <><h2 style={{color:"#b041ac"}}>Chat</h2><h1>|</h1><h2 onClick={switcherSet}>Work</h2></>}
{switcher && <><h2 onClick={switcherSet}>Chat</h2><h1>|</h1><h2 style={{color:"#b041ac"}}>Work</h2></>}
</div>
<div className='clickWrap' id='wrap' style={{opacity:white,zIndex:index}}></div>
<div className="gallery">
{!switcher && pics && pics.map((item,index)=>{
  if(item[1] === "1"){
  return (
    <div className='image' onClick={openImg} style={{cursor:"pointer"}} key={index}>{item[0] && <img src={item[0]}/>}</div>
  )
}else{
  return (
    <div className='image' key={index}>{item[0] && <img src={item[0]} className='blur'/>}</div>
  )
}
})}
{switcher && picsWork && picsWork.map((item,index)=>{
  if(item[1] === "1"){
  return (
    <div className='image' onClick={openImg} style={{cursor:"pointer"}} key={index}>{item[0] && <img src={item[0]}/>}</div>
  )
}else{
  return (
    <div className='image' key={index}>{item[0] && <img src={item[0]} className='blur'/>}</div>
  )
}
})}
{!switcher && <div className='image'><div><p>More photos are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={bigBoobsNaked} className='blurT'/></div>}
{!switcher && <div className='image'><div><p>More animations are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={doggyRubb} className='blurT'/></div>}
{switcher && <div className='image'><div><p>More photos are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img140} className='blurT'/></div>}
{switcher && <div className='image'><div><p>More photos are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img139} className='blurT'/></div>}
{switcher && <div className='image'><div><p>More photos are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img146} className='blurT'/></div>}

</div>
</div>
);

}

export default Gallery;
